import { PropsWithChildren } from 'react';

type ComponentTypes = {
  htmlFor?: string | number;
};

const CustomLabel = ({ htmlFor, children }: PropsWithChildren<ComponentTypes>) => {
  const htmlForString = htmlFor?.toString();
  return (
    <label
      style={{
        fontWeight: 700,
        fontSize: '14px',
        fontFamily: 'Lato',
        lineHeight: '24px',
      }}
      htmlFor={htmlForString}>
      {children}
    </label>
  );
};

export default CustomLabel;
